<template>
    <va-create-layout>
        <ShipmentEvent-form :title="title" :item="item"></ShipmentEvent-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
